import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Events, NavParams } from "ionic-angular";
import { PainSiteService } from "../../pain-site-card/pain-site.service";
import { NewWoundService } from "../new-wound.service";

/**
 * Generated class for the PhysicianSearchComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "new-wound-score",
  templateUrl: "new-wound-score.html",
})
export class NewWoundScoreComponent {
  painService: PainSiteService;
  sidebar: any;
  config: any;

  currentTool: string = null;
  currentValue: any;
  readonly: boolean = false;
  abbeyData: object = { tool: "abbey", values: null };
  wongBakerData: object = { tool: "wongBaker", values: null };
  numericData: object = { tool: "numeric", values: null };
  verbalData: object = { tool: "verbal", values: null };
  flaccData: object = { tool: "flacc", values: null };
  painADData: object = { tool: "painAD", values: null };
  existingData: object;
  data: any;
  toolConfig: any;
  abbeyConfig: boolean = false;
  flaccConfig: boolean = false;
  numericConfig: boolean = false;
  wongBakerConfig: boolean = false;
  painAdConfig: boolean = false;
  verbalConfig: boolean = false;
  severity: number;

  constructor(
    private newWoundService: NewWoundService,
    public translatePipe: TranslateService,
    public events: Events,
    params: NavParams
  ) {
    let data = params.data;
    this.config = data.config;
    this.painService = this.newWoundService.getPainService();
  }

  ngOnInit(): void {
    for (let i = 0; i < this.config.tabs.length; i++) {
      if (this.config.tabs[i].score) {
        for (let j = 0; j < this.config.tabs[i].score.length; j++) {
          if (this.config.tabs[i].score[j].sidebar)
            this.sidebar = this.config.tabs[i].score[j].sidebar;
          if (this.config.tabs[i].score[j].tools)
            this.toolConfig = this.config.tabs[i].score[j].tools;
        }
      }
    }

    this.abbeyConfig = this.toolConfig.filter((x) => x === "abbey").length > 0;
    this.flaccConfig = this.toolConfig.filter((x) => x === "flacc").length > 0;
    this.numericConfig =
      this.toolConfig.filter((x) => x === "numeric").length > 0;
    this.wongBakerConfig =
      this.toolConfig.filter((x) => x === "wongBaker").length > 0;
    this.painAdConfig =
      this.toolConfig.filter((x) => x === "painAD").length > 0;
    this.verbalConfig =
      this.toolConfig.filter((x) => x === "verbal").length > 0;

    this.newWoundService.getCurrentPointData().subscribe((currentWound) => {
      if (currentWound) {
        this.data = currentWound;
        if (currentWound.score) {
          this.currentTool = currentWound.score.tool;
          this.currentValue = currentWound.score.value
            ? currentWound.score.value["values"]
            : null;
          if (currentWound.score.tool === "flacc" && currentWound.score.value) {
            this.flaccData = {
              tool: this.currentTool,
              values: this.currentValue,
            };
          } else if (
            currentWound.score.tool === "wongBaker" &&
            currentWound.score.value
          ) {
            this.wongBakerData = {
              tool: this.currentTool,
              values: this.currentValue,
            };
          } else if (
            currentWound.score.tool === "numeric" &&
            currentWound.score.value
          ) {
            this.numericData = {
              tool: this.currentTool,
              values: this.currentValue,
            };
          } else if (
            currentWound.score.tool === "abbey" &&
            currentWound.score.value
          ) {
            this.abbeyData = {
              tool: this.currentTool,
              values: this.currentValue,
            };
          } else if (
            currentWound.score.tool === "painAD" &&
            currentWound.score.value
          ) {
            this.painADData = {
              tool: this.currentTool,
              values: this.currentValue,
            };
          } else if (
            currentWound.score.tool === "verbal" &&
            currentWound.score.value
          ) {
            this.verbalData = {
              tool: this.currentTool,
              values: this.currentValue,
            };
          }
        }
      }
    });
  }

  updateCardData(data) {
    if (
      this.data.woundStatus === "inprogress" ||
      this.data.woundStatus === "reassess"
    ) {
      this.currentTool = data.stepOneSidebarData.toolName;
      this.data.score = { tool: "", value: null };
      this.abbeyData = { tool: "abbey", values: null };
      this.wongBakerData = { tool: "wongBaker", values: null };
      this.numericData = { tool: "numeric", values: null };
      this.verbalData = { tool: "verbal", values: null };
      this.flaccData = { tool: "flacc", values: null };
      this.painADData = { tool: "painAD", values: null };
      this.data.stepOneSidebarData.severity = null;
    }
  }

  dataUpdate(data) {
    if (this.painToolsDefined(data) === false) {
      this.data.score = { tool: this.currentTool, value: data };
      this.data.stepOneSidebarData.severity = data.severity;
      this.newWoundService.setCurrentPointData(this.data);
    }
  }

  painToolsDefined(point) {
    let painValuesComplete = false;
    if (point) {
      for (let attr in point.values) {
        if (point.values[attr] === undefined || point.values[attr] === null) {
          painValuesComplete = true;
          break;
        }
      }
    }
    return painValuesComplete;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/new-wound-site-card/new-wound-score/new-wound-score.ts